import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { text } from "../text";
import { hooks } from "../hooks";
import { utils } from "../utils";
import { svg } from "../assets/svg";
import { theme } from "../constants";
import { components } from "../components";
import { colors } from "../constants/colors";
import { CrossSvg } from "../assets/svg/CrossSvg";
import { LocationSvg } from "../assets/svg/MyLocaiton";
import { LocationIconSvg } from "../assets/svg/LocationIconSvg";
import useApi from "../customHook/useApi";
import { fetchLocality, localityUrl } from "../environment";
import locationAllow from "../assets/nestfin/map.png";
import { CustomLoader, CustomLoaderSmall } from "../components/CustomLoader";
import SuccessModal from "../components/nodataFound/SuccessModal";
import { GoogleApi } from "./GoogleApi";

const popularLocalities = [
  {
    id: 1,
    locality: "GTB Nagar",
    city: "Delhi",
  },
  {
    id: 2,
    locality: "Mukherjee Nagar",
    city: "Delhi",
  },
  {
    id: 3,
    locality: "Model Town",
    city: "Delhi",
  },
  {
    id: 4,
    locality: "Shalimar Bagh",
    city: "Delhi",
  },
];

type Locality = {
  locality_id: number;
  locality_name: string;
  latitude: number;
  longitude: number;
};

export interface LocalityResponse {
  success: boolean;
  statusCode: number;
  data: Locality[];
  message?: string;
  localities?: [];
}

export const Onboarding6: React.FC = () => {
  // Define State Here
  const navigate = hooks.useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();
  // const [searchInput, setSearchInput] = useState<string>([]);
  const [searchInput, setSearchInput] = useState<string[]>([]);
  const [selectedLocalityIds, setSelectedLocalityIds] = useState<number[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [localityArray, setLocalityArray] = useState<Locality[]>([]);
  const [loading, setLoading] = useState(true);
  // const [selectedLocalityData, setSelectedLocalityData] = useState<{ locality_id: number; locality_name: string }[]>([]);

  const selectedCity = localStorage.getItem("selectedCity");

  const selectedCityId = localStorage.getItem("selectedCityId");

  // API CALL
  const {
    data: localityData,
    loading: localityLoading,
    callApi: fetchLocalities,
  } = useApi<LocalityResponse>(localityUrl, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 1. Trigger API on city change
  useEffect(() => {
    if (selectedCity) {
      // setLoading(true);
      fetchLocalities({ cityname: selectedCity });
      setTimeout(() => setLoading(false), 1000);
    }
  }, [selectedCity]);

  useEffect(() => {
    const selectedLocality = localStorage.getItem("selectedLocality");

    if (selectedLocality) {
      try {
        const parsedLocality = JSON.parse(selectedLocality);

        // ✅ Check if it's a valid non-empty array and doesn't contain only empty string
        if (
          Array.isArray(parsedLocality) &&
          parsedLocality.length > 0 &&
          parsedLocality[0] !== ""
        ) {
          setSearchInput(parsedLocality);
        } else {
          console.warn(
            "❗ Ignoring invalid or empty selectedLocality:",
            parsedLocality
          );
        }
      } catch (error) {
        console.error("Failed to parse selectedLocality:", error);
      }
    }

    if (localityData) {
      // console.log("✅ localityData received:", localityData.data);
      setLocalityArray(localityData?.data);
    }
  }, [localityData]);

  // 3. Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  // GET LOCALITY
  // API CALL
  // API CALL
  const {
    data: fetchLocalityData,
    loading: fetchLocalityLoading,
    callApi: fetchLocalitiesfun,
  } = useApi<LocalityResponse>(fetchLocality, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // Log the response when data changes
  useEffect(() => {
    console.log(fetchLocalityData?.localities, "fetchLocalityData");
  }, [fetchLocalityData]);

  // Trigger API when selectedCityId changes
  useEffect(() => {
    if (selectedCityId) {
      console.log("Calling API with:", { city: selectedCityId });
      fetchLocalitiesfun({ city: selectedCityId });
    }
  }, [selectedCityId]);

  const handleLocalityClick = (locality: string) => {
    if (!searchInput?.includes(locality)) {
      setSearchInput((prev) => [...prev, locality]);
    }
  };

  // HANDLE THE LOCALITY SAVE SESSION STRORAGE

  const handleApply = () => {
    // localStorage.setItem("selectedLocality", JSON.stringify(searchInput));

    // Save full data (used for ID lookup later)
    // localStorage.setItem(
    //   "selectedLocalityFull",
    //   JSON.stringify(
    //     searchInput.map((name) => {
    //       const match = localityArray?.find((l) => l.locality_name === name);
    //       return { locality_name: name, locality_id: match?.locality_id || 0 };
    //     })
    //   )
    // );

    const previousIdsRaw = localStorage.getItem("SelectedLocalityId");
    const previousIds = previousIdsRaw
      ? previousIdsRaw.split(",").map((id) => id.trim())
      : [];

    const currentIds = searchInput
      .map((name) => {
        const match = localityArray?.find((l) => l.locality_name === name);
        return match ? String(match.locality_id) : "";
      })
      .filter(Boolean);

    const allIds = Array.from(new Set([...previousIds, ...currentIds]));
    // localStorage.setItem("SelectedLocalityId", allIds.join(", "));
    // console.log("allids: ", allIds);
    navigate("/onbording7");
  };

  const handleRemoveChips = (locToRemove: string) => {
    // 1. Remove name from search input (string[])
    const updatedSearchInput = searchInput.filter(
      (item) => item !== locToRemove
    );
    setSearchInput(updatedSearchInput);
    localStorage.setItem(
      "selectedLocality",
      JSON.stringify(updatedSearchInput)
    );

    // 2. Remove from full locality objects
    const updatedFullLocalities = localityArray?.filter((loc) =>
      updatedSearchInput.includes(loc.locality_name)
    );
    localStorage.setItem(
      "selectedLocalityFull",
      JSON.stringify(updatedFullLocalities)
    );

    // 3. Extract and save comma-separated ID string
    const selectedLocalityIds = updatedFullLocalities.map(
      (loc) => loc.locality_id
    );
    // localStorage.setItem("SelectedLocalityId", selectedLocalityIds.join(","));

    // 4. Update filtered dropdown (if needed)
    const updatedDropdownData = localityArray?.filter(
      (loc) =>
        !updatedSearchInput.includes(loc.locality_name) &&
        loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilterData(updatedDropdownData);
  };

  const handleChangeCity = () => {
    // localStorage.clear()
    localStorage.removeItem("selectedLocality");
    localStorage.removeItem("selectedLocalityFull");
    localStorage.removeItem("selectedLocalityId");
    navigate("/onbording5");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const value = e.currentTarget.value.trim();
      if (value && !searchInput?.includes(value)) {
        setSearchInput((prev) => [...prev, value]);
      }
      e.currentTarget.value = "";
    }
  };

  const [filterdata, setFilterData] = useState<Locality[]>(localityArray);

  // this is my onchange Event
  const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.trim() === "") {
      setShowDropdown(false);
      setFilterData([]);
      return;
    }

    setShowDropdown(true);

    const data = localityArray
      ?.filter((locality) =>
        locality.locality_name.toLowerCase().includes(value.toLowerCase())
      )
      ?.filter((locality) => !searchInput?.includes(locality.locality_name));

    setFilterData(data);
  };

  const handleDropDownClick = (localityName: string, localityId: number) => {
    console.log("Selected ID:", localityId);

    setInputValue("");

    const value = localityName.trim();
    setSearchInput((prev) => [...prev, value]); // add locality name

    setSelectedLocalityIds((prev) => {
      const updatedIds = [...prev, localityId];

      // Optional: store instantly (if needed)
      // localStorage.setItem("SelectedLocality", updatedIds.join(","));

      console.log("All selected IDs (string):", updatedIds.join(","));
      return updatedIds;
    });

    setShowDropdown(false);
  };

  const handleClearInput = () => {
    setInputValue("");
    setShowDropdown(false);
  };

  const [showLocationPopup, setShowLocationPopup] = useState(false);

  // show popup based on locality if yes show
  useEffect(() => {
    const selectedLocality = localStorage.getItem("selectedLocality");

    try {
      const parsedLocality = JSON.parse(selectedLocality || "[]");

      // If we have at least one valid non-empty locality, don't show the popup
      if (
        Array.isArray(parsedLocality) &&
        parsedLocality.length > 0 &&
        parsedLocality[0] !== ""
      ) {
        setShowLocationPopup(false);
      } else {
        // setShowLocationPopup(true);
      }
    } catch (error) {
      console.error("Error parsing selectedLocality:", error);
      // setShowLocationPopup(true);
    }
  }, []);

  const hanldeAllowLocation = (location: string) => {
    setShowLocationPopup(false);

    if (location === "Allow") {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            console.log("User location:", latitude, longitude);

            // --- Step 1: Find nearest locality using Haversine formula ---
            const toRad = (value: number) => (value * Math.PI) / 180;

            const calculateDistance = (
              lat1: number,
              lon1: number,
              lat2: number,
              lon2: number
            ) => {
              const R = 6371; // Radius of Earth (km)
              const dLat = toRad(lat2 - lat1);
              const dLon = toRad(lon2 - lon1);
              const a =
                Math.sin(dLat / 2) ** 2 +
                Math.cos(toRad(lat1)) *
                  Math.cos(toRad(lat2)) *
                  Math.sin(dLon / 2) ** 2;
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              return R * c;
            };

            let nearest = null;
            let minDist = Number.MAX_VALUE;

            for (const loc of localityArray) {
              if (loc.latitude && loc.longitude) {
                const dist = calculateDistance(
                  latitude,
                  longitude,
                  loc.latitude,
                  loc.longitude
                );
                if (dist < minDist) {
                  minDist = dist;
                  nearest = loc;
                }
              }
            }

            // --- Step 2: If nearest locality found, add it ---
            if (nearest) {
              const name = nearest.locality_name;
              const id = nearest.locality_id;

              setSearchInput((prev) => {
                if (!prev.includes(name)) {
                  const updatedNames = [...prev, name];
                  localStorage.setItem(
                    "selectedLocality",
                    JSON.stringify(updatedNames)
                  );

                  // Save selectedLocalityFull for mapping name ↔ id
                  const selectedFull = [...updatedNames].map((localityName) => {
                    const match = localityArray.find(
                      (loc) => loc.locality_name === localityName
                    );
                    return {
                      locality_id: match?.locality_id || 0,
                      locality_name: localityName,
                    };
                  });
                  localStorage.setItem(
                    "selectedLocalityFull",
                    JSON.stringify(selectedFull)
                  );

                  // Save IDs
                  // const updatedIds = selectedFull
                  //   .map((item) => item.locality_id)
                  //   .join(",");
                  // localStorage.setItem("SelectedLocalityId", updatedIds);

                  navigate("/onbording7");
                  return updatedNames;
                } else {
                  // Already exists, but still store
                  localStorage.setItem(
                    "selectedLocality",
                    JSON.stringify(prev)
                  );
                  navigate("/onbording7");
                  return prev;
                }
              });
            } else {
              console.log("❌ Could not find nearest locality");
            }
          },
          (error) => {
            console.error("Geolocation error:", error.message);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    }

    if (location === "Don't Allow") {
      console.log("User denied location access.");
    }
  };

  // Start component here

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title=""
        goBack={true}
        skip={true}
        clear={false}
        clearOnClicked={() => {}}
      />
    );
  };

  const renderTitle = (): JSX.Element => {
    return (
      <div className="container" style={{ marginTop: 30 }}>
        <p className="headingCity" style={{ textAlign: "center" }}>
          You are looking to rent in
        </p>

        <div className="changeCityContainer">
          <p className="paraCity leftText">
            Select Locality in{" "}
            <span className="cityHighlight">{selectedCity}</span>
          </p>
          <p
            className="paraCity leftText boldText"
            style={{ color: "blue", cursor: "pointer" }}
            // onClick={() => navigate('/onbording5')}
            onClick={handleChangeCity}
          >
            Change City
          </p>
        </div>
      </div>
    );
  };

  const renderLocalityList = (): JSX.Element | null => {
    const handleLocalityClick = (item: any) => {
      const { locality, latitude, longitude } = item;
      if (!locality) return;

      // --- Construct full string ---
      const fullString = `${locality}, ${selectedCity}, India`;

      // --- Handle selectedLocality ---
      const previousLocalitiesRaw = localStorage.getItem("selectedLocality");
      let previousLocalities: string[] = [];

      if (previousLocalitiesRaw) {
        try {
          previousLocalities = JSON.parse(previousLocalitiesRaw);
        } catch {
          previousLocalities = [previousLocalitiesRaw];
        }
      }

      const updatedLocalities = previousLocalities.includes(fullString)
        ? previousLocalities
        : [...previousLocalities, fullString];

      localStorage.setItem(
        "selectedLocality",
        JSON.stringify(updatedLocalities)
      );

      // --- Handle selectedLatLng ---
      const previousLatLngRaw = localStorage.getItem("selectedLatLng");
      let previousLatLng: { lat: number; lon: number }[] = [];

      if (previousLatLngRaw) {
        try {
          previousLatLng = JSON.parse(previousLatLngRaw);
        } catch {
          previousLatLng = [];
        }
      }

      const lat = latitude ?? 0;
      const lon = longitude ?? 0;

      const updatedLatLng = [...previousLatLng, { lat, lon }];
      localStorage.setItem("selectedLatLng", JSON.stringify(updatedLatLng));

      console.log("✅ Locality clicked:", fullString);
      console.log("📍 Updated selectedLocality:", updatedLocalities);
      console.log("🗺️ Updated selectedLatLng:", updatedLatLng);

      // --- Navigate to /ONBOARDING7 ---
      navigate("/search-result");
    };

    // Loading check
    if (fetchLocalityLoading) {
      return (
        <div className="container" style={{ marginTop: 20 }}>
          <p className="paraCity leftText">Popular Localities</p>
          <div>{CustomLoader()}</div>
        </div>
      );
    }

    // Empty check
    if (!fetchLocalityData?.localities?.length) return null;

    return (
      <div className="container" style={{ marginTop: 20 }}>
        <p className="paraCity leftText">Popular Localities</p>

        <div
          style={{
            maxHeight: 300,
            overflowY: "auto",
            marginTop: "15px",
          }}
        >
          {fetchLocalityData.localities
            .slice(0, 7)
            .map((item: any, index: number) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: 5,
                  marginBottom: 10,
                  cursor: "pointer",
                }}
                onClick={() => handleLocalityClick(item)}
              >
                {" "}
                {/* <h1>rns</h1> */}
                <div
                  style={{
                    flex: "0 0 20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: 12,
                  }}
                >
                  <svg
                    style={{ width: "17px", height: "17px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </div>
                <div className="" style={{ flex: 1 }}>
                  <p
                    style={{
                      color: "#333",
                      marginBottom: 5,
                      fontSize: "13px",
                    }}
                  >
                    {item.locality}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  };

  const renderButton = (): JSX.Element => {
    return (
      <div
        id="onbording3"
        style={{
          backgroundColor: "var(--primary-color)",
          color: "white",
          borderColor: "var(--primary-color)",
        }}
        onClick={handleApply}
      >
        <span>Apply</span>
      </div>
    );
  };

  const renderSearchBar = (): JSX.Element => {
    return (
      <div className="container">
        {/* <div
          className="searchBar"
          style={{
            marginTop: "9px",
            display: "flex",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "5px 16px",
            gap: "6px",
          }}
        >
          <span style={{ flexShrink: 0 }}>
            <svg.SearchSvg />
          </span>
          <input
            type="text"
            placeholder="Search Localities here"
            className="searchInput"
            maxLength={30}
            style={{
              border: "none",
              outline: "none",
              flex: 1,
              minWidth: "120px",
              position:"relative"
            }}
            value={inputValue}
            onChange={(e) => handleLocalityDropDown(e)}
          />

          {inputValue && (
            <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
              <CrossSvg
                color="#000000c7"
                width={13}
                height={13}
                style={{ marginRight: 8 }}
              />
            </span>
          )}
        </div> */}
        <GoogleApi />
        {/* Chips for selected localities */}
        {/* {searchInput.length > 0 && (
          <div
            style={{
              display: "flex",
              overflow: "auto",
              flexWrap: "nowrap",
              gap: "6px",
              flex: 1,
              margin: "18px 0",
            }}
          >
            {searchInput
              .slice()
              .reverse()
              .map((loc, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "var(--secondary-color)",
                    // backgroundColor: "#7065f0d6",
                    borderRadius: "5px",
                    padding: "9px 10px",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    color: "white",
                  }}
                >
                  <span>{loc}</span>
                  <span
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      color: "#fff",
                      marginLeft: "8px",
                    }}
                    onClick={() => handleRemoveChips(loc)}
                  >
                    × 
                  </span>
                </div>
              ))}
          </div>
        )} */}

        {showDropdown && (
          <div className="localityResult">
            {filterdata.length > 0 ? (
              filterdata.map((item, index) => {
                // console.log("Dropdown Item:", item);
                return (
                  <p
                    key={index}
                    onClick={() =>
                      handleDropDownClick(item.locality_name, item.locality_id)
                    }
                  >
                    <span role="img" aria-label="location">
                      <LocationIconSvg
                        width={15}
                        height={15}
                        style={{ marginTop: 8 }}
                      />
                    </span>{" "}
                    {item.locality_name}
                  </p>
                );
              })
            ) : (
              <p className="noResult">No results found</p>
            )}
          </div>
        )}

        {/* <div
          className="useLocation"
          style={{ marginTop: "10px" }}
          onClick={() => setShowLocationPopup(true)}
        >
          <svg.LocationSvg color="var(--secondary-color)" />
          <span>Use My Current Location</span>
        </div> */}
      </div>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100dvh", // or '100vh' if preferred
          paddingBottom: 10,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 1,
            overflowY: "auto",
          }}
        >
          {/* {renderTitle()} */}
          {renderSearchBar()}
          {renderLocalityList()}
          {/* {renderLocalityList()} */}
          {/* {loading ? (
            <div style={{ marginTop: "15px" }}>{CustomLoaderSmall()}</div>
          ) : (
            <>{renderLocalityList()}</>
          )} */}
        </div>

        <div style={{ padding: "0 20px 10px" }}>{renderButton()}</div>
      </main>
    );
  };

  const renderFetchLocation = (): JSX.Element => {
    return (
      <h1 style={{ color: "black" }}>
        I am location Code Lorem ipsum dolor sit amet consectetur adipisicing
        elit. Nobis voluptatum reprehenderit aut quaerat numquam, eum quidem
        maiores delectus molestiae itaque obcaecati ea ullam id unde odio
        distinctio libero ex explicabo.
      </h1>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}

      {/* {localityLoading ? <>{CustomLoader()}</> : <>{renderContent()}</>} */}
      {/* {renderFetchLocation()} */}

      {showLocationPopup && (
        <div className="location-overlay">
          <div className="location-modal">
            <div className="location-buttons">
              <div className="img-container">
                <img src={locationAllow} alt="Location" width="100" />
              </div>
              <div className="locationContent">
                <h3>Allow your location </h3>
                <p>
                  To help you find the best options near you, we need access to
                  your location. Your privacy is important to us.
                </p>
              </div>
              <button
                className="allow-btn"
                onClick={() => hanldeAllowLocation("Allow")}
              >
                Allow{" "}
              </button>
              <button
                className="deny-btn"
                onClick={() => hanldeAllowLocation("Don't Allow")}
              >
                Don't Allow
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";

// import { text } from "../text";
// import { hooks } from "../hooks";
// import { utils } from "../utils";
// import { svg } from "../assets/svg";
// import { theme } from "../constants";
// import { components } from "../components";
// import { colors } from "../constants/colors";
// import { CrossSvg } from "../assets/svg/CrossSvg";
// import { LocationSvg } from "../assets/svg/MyLocaiton";
// import { LocationIconSvg } from "../assets/svg/LocationIconSvg";
// import useApi from "../customHook/useApi";
// import { localityUrl } from "../environment";
// import locationAllow from "../assets/nestfin/map.png";
// import { CustomLoader, CustomLoaderSmall } from "../components/CustomLoader";
// import SuccessModal from "../components/nodataFound/SuccessModal";

// const popularLocalities = [
//   {
//     id: 1,
//     locality: "GTB Nagar",
//     city: "Delhi",
//   },
//   {
//     id: 2,
//     locality: "Mukherjee Nagar",
//     city: "Delhi",
//   },
//   {
//     id: 3,
//     locality: "Model Town",
//     city: "Delhi",
//   },
//   {
//     id: 4,
//     locality: "Shalimar Bagh",
//     city: "Delhi",
//   },
// ];

// type Locality = {
//   locality_id: number;
//   locality_name: string;
//   latitude: number;
//   longitude: number;
// };

// export interface LocalityResponse {
//   success: boolean;
//   statusCode: number;
//   data: Locality[];
//   message?: string;
// }

// export const Onboarding6: React.FC = () => {
//   // Define State Here
//   const navigate = hooks.useNavigate();
//   const location = useLocation();
//   const { pathname } = useLocation();
//   // const [searchInput, setSearchInput] = useState<string>([]);
//   const [searchInput, setSearchInput] = useState<string[]>([]);
//   const [selectedLocalityIds, setSelectedLocalityIds] = useState<number[]>([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [inputValue, setInputValue] = useState("");
//   const [localityArray, setLocalityArray] = useState<Locality[]>([]);
//   const [loading, setLoading] = useState(true);
//   // const [selectedLocalityData, setSelectedLocalityData] = useState<{ locality_id: number; locality_name: string }[]>([]);

//   const selectedCity = localStorage.getItem("selectedCity");

//   // API CALL
//   const {
//     data: localityData,
//     loading: localityLoading,
//     callApi: fetchLocalities,
//   } = useApi<LocalityResponse>(localityUrl, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   // 1. Trigger API on city change
//   useEffect(() => {
//     if (selectedCity) {
//       // setLoading(true);
//       fetchLocalities({ cityname: selectedCity });
//       setTimeout(() => setLoading(false), 1000);
//     }
//   }, [selectedCity]);

//   useEffect(() => {
//     const selectedLocality = localStorage.getItem("selectedLocality");

//     if (selectedLocality) {
//       try {
//         const parsedLocality = JSON.parse(selectedLocality);

//         // ✅ Check if it's a valid non-empty array and doesn't contain only empty string
//         if (
//           Array.isArray(parsedLocality) &&
//           parsedLocality.length > 0 &&
//           parsedLocality[0] !== ""
//         ) {
//           setSearchInput(parsedLocality);
//         } else {
//           console.warn(
//             "❗ Ignoring invalid or empty selectedLocality:",
//             parsedLocality
//           );
//         }
//       } catch (error) {
//         console.error("Failed to parse selectedLocality:", error);
//       }
//     }

//     if (localityData) {
//       console.log("✅ localityData received:", localityData.data);
//       setLocalityArray(localityData?.data);
//     }
//   }, [localityData]);

//   // 3. Scroll to top on route change
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     document.documentElement.scrollTop = 0;
//   }, [pathname]);

//   const handleLocalityClick = (locality: string) => {
//     if (!searchInput?.includes(locality)) {
//       setSearchInput((prev) => [...prev, locality]);
//     }
//   };

//   const handleApply = () => {
//     localStorage.setItem("selectedLocality", JSON.stringify(searchInput));

//     // Save full data (used for ID lookup later)
//     localStorage.setItem(
//       "selectedLocalityFull",
//       JSON.stringify(
//         searchInput.map((name) => {
//           const match = localityArray?.find((l) => l.locality_name === name);
//           return { locality_name: name, locality_id: match?.locality_id || 0 };
//         })
//       )
//     );

//     const previousIdsRaw = localStorage.getItem("SelectedLocalityId");
//     const previousIds = previousIdsRaw
//       ? previousIdsRaw.split(",").map((id) => id.trim())
//       : [];

//     const currentIds = searchInput
//       .map((name) => {
//         const match = localityArray?.find((l) => l.locality_name === name);
//         return match ? String(match.locality_id) : "";
//       })
//       .filter(Boolean);

//     const allIds = Array.from(new Set([...previousIds, ...currentIds]));
//     localStorage.setItem("SelectedLocalityId", allIds.join(", "));

//     navigate("/onbording7");
//   };

//   const handleRemoveChips = (locToRemove: string) => {
//     // 1. Remove name from search input (string[])
//     const updatedSearchInput = searchInput.filter(
//       (item) => item !== locToRemove
//     );
//     setSearchInput(updatedSearchInput);
//     localStorage.setItem(
//       "selectedLocality",
//       JSON.stringify(updatedSearchInput)
//     );

//     // 2. Remove from full locality objects
//     const updatedFullLocalities = localityArray?.filter((loc) =>
//       updatedSearchInput.includes(loc.locality_name)
//     );
//     localStorage.setItem(
//       "selectedLocalityFull",
//       JSON.stringify(updatedFullLocalities)
//     );

//     // 3. Extract and save comma-separated ID string
//     const selectedLocalityIds = updatedFullLocalities.map(
//       (loc) => loc.locality_id
//     );
//     localStorage.setItem("SelectedLocalityId", selectedLocalityIds.join(","));

//     // 4. Update filtered dropdown (if needed)
//     const updatedDropdownData = localityArray?.filter(
//       (loc) =>
//         !updatedSearchInput.includes(loc.locality_name) &&
//         loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
//     );
//     setFilterData(updatedDropdownData);
//   };

//   const handleChangeCity = () => {
//     // localStorage.clear()
//     localStorage.removeItem("selectedLocality");
//     localStorage.removeItem("selectedLocalityFull");
//     localStorage.removeItem("selectedLocalityId");
//     navigate("/onbording5");
//   };

//   const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === "Enter") {
//       const value = e.currentTarget.value.trim();
//       if (value && !searchInput?.includes(value)) {
//         setSearchInput((prev) => [...prev, value]);
//       }
//       e.currentTarget.value = "";
//     }
//   };

//   const [filterdata, setFilterData] = useState<Locality[]>(localityArray);

//   // this is my onchange Event
//   const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = e.target.value;
//     setInputValue(value);

//     if (value.trim() === "") {
//       setShowDropdown(false);
//       setFilterData([]);
//       return;
//     }

//     setShowDropdown(true);

//     const data = localityArray
//       ?.filter((locality) =>
//         locality.locality_name.toLowerCase().includes(value.toLowerCase())
//       )
//       ?.filter((locality) => !searchInput?.includes(locality.locality_name));

//     setFilterData(data);
//   };

//   const handleDropDownClick = (localityName: string, localityId: number) => {
//     console.log("Selected ID:", localityId);

//     setInputValue("");

//     const value = localityName.trim();
//     setSearchInput((prev) => [...prev, value]); // add locality name

//     setSelectedLocalityIds((prev) => {
//       const updatedIds = [...prev, localityId];

//       // Optional: store instantly (if needed)
//       // localStorage.setItem("SelectedLocality", updatedIds.join(","));

//       console.log("All selected IDs (string):", updatedIds.join(","));
//       return updatedIds;
//     });

//     setShowDropdown(false);
//   };

//   const handleClearInput = () => {
//     setInputValue("");
//     setShowDropdown(false);
//   };

//   const [showLocationPopup, setShowLocationPopup] = useState(false);

//   // show popup based on locality if yes show
//   useEffect(() => {
//     const selectedLocality = localStorage.getItem("selectedLocality");

//     try {
//       const parsedLocality = JSON.parse(selectedLocality || "[]");

//       // If we have at least one valid non-empty locality, don't show the popup
//       if (
//         Array.isArray(parsedLocality) &&
//         parsedLocality.length > 0 &&
//         parsedLocality[0] !== ""
//       ) {
//         setShowLocationPopup(false);
//       } else {
//         // setShowLocationPopup(true);
//       }
//     } catch (error) {
//       console.error("Error parsing selectedLocality:", error);
//       setShowLocationPopup(true); // show popup if parsing fails
//     }
//   }, []);

//   const hanldeAllowLocation = (location: string) => {
//     setShowLocationPopup(false);

//     if (location === "Allow") {
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const { latitude, longitude } = position.coords;
//             console.log("User location:", latitude, longitude);

//             // --- Step 1: Find nearest locality using Haversine formula ---
//             const toRad = (value: number) => (value * Math.PI) / 180;

//             const calculateDistance = (
//               lat1: number,
//               lon1: number,
//               lat2: number,
//               lon2: number
//             ) => {
//               const R = 6371; // Radius of Earth (km)
//               const dLat = toRad(lat2 - lat1);
//               const dLon = toRad(lon2 - lon1);
//               const a =
//                 Math.sin(dLat / 2) ** 2 +
//                 Math.cos(toRad(lat1)) *
//                   Math.cos(toRad(lat2)) *
//                   Math.sin(dLon / 2) ** 2;
//               const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//               return R * c;
//             };

//             let nearest = null;
//             let minDist = Number.MAX_VALUE;

//             for (const loc of localityArray) {
//               if (loc.latitude && loc.longitude) {
//                 const dist = calculateDistance(
//                   latitude,
//                   longitude,
//                   loc.latitude,
//                   loc.longitude
//                 );
//                 if (dist < minDist) {
//                   minDist = dist;
//                   nearest = loc;
//                 }
//               }
//             }

//             // --- Step 2: If nearest locality found, add it ---
//             if (nearest) {
//               const name = nearest.locality_name;
//               const id = nearest.locality_id;

//               setSearchInput((prev) => {
//                 if (!prev.includes(name)) {
//                   const updatedNames = [...prev, name];
//                   localStorage.setItem(
//                     "selectedLocality",
//                     JSON.stringify(updatedNames)
//                   );

//                   // Save selectedLocalityFull for mapping name ↔ id
//                   const selectedFull = [...updatedNames].map((localityName) => {
//                     const match = localityArray.find(
//                       (loc) => loc.locality_name === localityName
//                     );
//                     return {
//                       locality_id: match?.locality_id || 0,
//                       locality_name: localityName,
//                     };
//                   });
//                   localStorage.setItem(
//                     "selectedLocalityFull",
//                     JSON.stringify(selectedFull)
//                   );

//                   // Save IDs
//                   const updatedIds = selectedFull
//                     .map((item) => item.locality_id)
//                     .join(",");
//                   localStorage.setItem("SelectedLocalityId", updatedIds);

//                   navigate("/onbording7");
//                   return updatedNames;
//                 } else {
//                   // Already exists, but still store
//                   localStorage.setItem(
//                     "selectedLocality",
//                     JSON.stringify(prev)
//                   );
//                   navigate("/onbording7");
//                   return prev;
//                 }
//               });
//             } else {
//               console.log("❌ Could not find nearest locality");
//             }
//           },
//           (error) => {
//             console.error("Geolocation error:", error.message);
//           }
//         );
//       } else {
//         console.error("Geolocation is not supported by this browser.");
//       }
//     }

//     if (location === "Don't Allow") {
//       console.log("User denied location access.");
//     }
//   };

//   // Start component here

//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         title=""
//         goBack={true}
//         skip={true}
//         clear={false}
//         clearOnClicked={() => {}}
//       />
//     );
//   };

//   const renderTitle = (): JSX.Element => {
//     return (
//       <div className="container" style={{ marginTop: 30 }}>
//         <p className="headingCity" style={{ textAlign: "left" }}>
//           You are looking to rent in
//         </p>

//         <div className="changeCityContainer">
//           <p className="paraCity leftText">
//             Select Locality in{" "}
//             <span className="cityHighlight">{selectedCity}</span>
//           </p>
//           <p
//             className="paraCity leftText boldText"
//           style={{ color: "blue", cursor: "pointer" }}
//             // onClick={() => navigate('/onbording5')}
//             onClick={handleChangeCity}
//           >
//             Change City
//           </p>
//         </div>
//       </div>
//     );
//   };

//   const renderLocalityList = (): JSX.Element | null => {
//     if (!localityArray.length) return null;
//     return (
//       <div className="container" style={{ marginTop: 20 }}>
//         <p className="paraCity leftText ">Popular Localities</p>
//         <div
//           style={{
//             maxHeight: 300,
//             overflowY: "auto",
//             marginTop: "15px",
//           }}
//         >
//           {localityLoading ? (
//             <div>{CustomLoaderSmall()}</div>
//           ) : (
//             <>
//               {localityArray?.slice(4, 8)?.map((item) => (
//                 <div
//                   key={item.locality_id}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     padding: "8px",
//                     border: "1px solid #ccc",
//                     borderRadius: 5,
//                     marginBottom: 10,
//                   }}
//                   onClick={() => handleLocalityClick(item.locality_name)}
//                 >
//                   <div
//                     style={{
//                       flex: "0 0 20px",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       marginRight: 12,
//                     }}
//                   >
//                     <svg
//                       style={{ width: "20px", height: "20px" }}
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M12 4v16m8-8H4"
//                       />
//                     </svg>
//                   </div>

//                   <div style={{ flex: 1 }}>
//                     <text.T14
//                       style={{
//                         color: "#333",
//                         // fontWeight: 'bold',
//                         marginBottom: 5,
//                         // fontSize: "10px"
//                       }}
//                     >
//                       {item.locality_name}
//                     </text.T14>
//                   </div>
//                 </div>
//               ))}
//             </>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const renderButton = (): JSX.Element => {
//     return (
//       <div
//         id="onbording3"
//         style={{
//           backgroundColor: "var(--primary-color)",
//           color: "white",
//           borderColor: "var(--primary-color)",
//         }}
//         onClick={handleApply}
//       >
//         <span>Apply</span>
//       </div>
//     );
//   };

//   const renderSearchBar = (): JSX.Element => {
//     return (
//       <div className="container">
//         <div
//           className="searchBar"
//           style={{
//             marginTop: "9px",
//             display: "flex",
//             alignItems: "center",
//             border: "1px solid #ccc",
//             borderRadius: "8px",
//             padding: "5px 16px",
//             gap: "6px",
//           }}
//         >
//           <span style={{ flexShrink: 0 }}>
//             <svg.SearchSvg />
//           </span>

//           {/* {searchInput.length > 0 && <div> | </div>} */}
//           {/* Flexible input field */}
//           <input
//             type="text"
//             placeholder="Search Localities here"
//             className="searchInput"
//             maxLength={30}
//             style={{
//               border: "none",
//               outline: "none",
//               flex: 1,
//               minWidth: "120px",
//               position:"relative"
//             }}
//             value={inputValue}
//             // onKeyDown={handleKeyDown}
//             onChange={(e) => handleLocalityDropDown(e)}
//           />

//           {inputValue && (
//             <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//               <CrossSvg
//                 color="#000000c7"
//                 width={13}
//                 height={13}
//                 style={{ marginRight: 8 }}
//               />
//             </span>
//           )}
//         </div>
//         {/* Chips for selected localities */}
//         {searchInput.length > 0 && (
//           <div
//             style={{
//               display: "flex",
//               overflow: "auto",
//               flexWrap: "nowrap",
//               gap: "6px",
//               flex: 1,
//               margin: "18px 0",
//             }}
//           >
//             {searchInput
//               .slice()
//               .reverse()
//               .map((loc, idx) => (
//                 <div
//                   key={idx}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     backgroundColor: "var(--secondary-color)",
//                     // backgroundColor: "#7065f0d6",
//                     borderRadius: "5px",
//                     padding: "9px 10px",
//                     fontSize: "14px",
//                     whiteSpace: "nowrap",
//                     color: "white",
//                   }}
//                 >
//                   <span>{loc}</span>
//                   <span
//                     style={{
//                       cursor: "pointer",
//                       fontWeight: "bold",
//                       color: "#fff",
//                       marginLeft: "8px",
//                     }}
//                     onClick={() => handleRemoveChips(loc)}
//                   >
//                     ×
//                   </span>
//                 </div>
//               ))}
//           </div>
//         )}

//         {showDropdown && (
//           <div className="localityResult">
//             {filterdata.length > 0 ? (
//               filterdata.map((item, index) => {
//                 // console.log("Dropdown Item:", item);
//                 return (
//                   <p
//                     key={index}
//                     onClick={() =>
//                       handleDropDownClick(item.locality_name, item.locality_id)
//                     }
//                   >
//                     <span role="img" aria-label="location">
//                       <LocationIconSvg
//                         width={15}
//                         height={15}
//                         style={{ marginTop: 8 }}
//                       />
//                     </span>{" "}
//                     {item.locality_name}
//                   </p>
//                 );
//               })
//             ) : (
//               <p className="noResult">No results found</p>
//             )}
//           </div>
//         )}

//         <div
//           className="useLocation"
//           style={{ marginTop: "10px" }}
//           onClick={() => setShowLocationPopup(true)}
//         >
//           <svg.LocationSvg color="var(--secondary-color)" />
//           <span>Use My Current Location</span>
//         </div>
//       </div>
//     );
//   };

//   const renderContent = (): JSX.Element => {
//     return (
//       <main
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "space-between",
//           height: "100dvh", // or '100vh' if preferred
//           paddingBottom: 10,
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             flex: 1,
//             overflowY: "auto",
//           }}
//         >
//           {renderTitle()}
//           {renderSearchBar()}
//           {renderLocalityList()}
//           {/* {loading ? (
//             <div style={{ marginTop: "15px" }}>{CustomLoaderSmall()}</div>
//           ) : (
//             <>{renderLocalityList()}</>
//           )} */}
//         </div>

//         <div style={{ padding: "0 20px 10px" }}>{renderButton()}</div>
//       </main>
//     );
//   };

//   const renderFetchLocation = (): JSX.Element => {
//     return (
//       <h1 style={{ color: "black" }}>
//         I am location Code Lorem ipsum dolor sit amet consectetur adipisicing
//         elit. Nobis voluptatum reprehenderit aut quaerat numquam, eum quidem
//         maiores delectus molestiae itaque obcaecati ea ullam id unde odio
//         distinctio libero ex explicabo.
//       </h1>
//     );
//   };

//   return (
//     <>
//       {renderHeader()}
//       {renderContent()}
//       {/* {localityLoading ? <>{CustomLoader()}</> : <>{renderContent()}</>} */}
//       {/* {renderFetchLocation()} */}

//       {showLocationPopup && (
//         <div className="location-overlay">
//           <div className="location-modal">
//             <div className="location-buttons">
//               <div className="img-container">
//                 <img src={locationAllow} alt="Location" width="100" />
//               </div>
//               <div className="locationContent">
//                 <h3>Allow your location </h3>
//                 <p>
//                   To help you find the best options near you, we need access to
//                   your location. Your privacy is important to us.
//                 </p>
//               </div>
//               <button
//                 className="allow-btn"
//                 onClick={() => hanldeAllowLocation("Allow")}
//               >
//                 Allow{" "}
//               </button>
//               <button
//                 className="deny-btn"
//                 onClick={() => hanldeAllowLocation("Don't Allow")}
//               >
//                 Don't Allow
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </>
//   );
// };
